import * as actionTypes from "../ActionTypes";
import { updateObject } from '../utility';

const initialState = {
  isFetching: false,
  hasError: false,
  paymentRes:{},
  errorMessage:''
}

const paymentReducer = (state = initialState, action) => {
  switch(action.type){
    case actionTypes.PAYMENT_INITIAL_REQUEST:
      return updateObject(state, {isFetching:true});
    case actionTypes.PAYMENT_INITIAL_SUCCESS:
      return updateObject(state, {paymentRes:action.data, isFetching:false});
    case actionTypes.PAYMENT_INITIAL_FAILURE:
      return updateObject(state, {isFetching:false});
    default:
      return state;
  }
}

export default paymentReducer;